<template>
  <section class="faq-section py-5">
    <div class="container px-3 col-lg-8">
      <h2 class="display-4 text-center mb-5 text-gradient-primary">Preguntas Frecuentes</h2>
      
      <div class="accordion" id="faqAccordion">
        <div class="accordion-item" v-for="(faq, index) in faqs" :key="index">
          <h3 class="accordion-header">
            <button 
              class="accordion-button" 
              :class="{ 'collapsed': !faq.isOpen }"
              type="button"
              @click="toggleFaq(index)"
            >
              {{ faq.question }}
            </button>
          </h3>
          <div 
            class="accordion-collapse"
            :class="{ 'show': faq.isOpen }"
          >
            <div class="accordion-body" v-html="faq.answer"></div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center flex-column pt-4">
        <p>
            ¿No encontraste la respuesta que buscabas?
        </p>
        <a class="btn btn-primary fs-6" href="https://wa.me/+5491150542815" target="_blank">
          Contactanos</a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const faqs = ref([
  {
    question: "¿Realizan envíos a todo el país?",
    answer: "Sí, realizamos envíos a todo el país a través de Correo Argentino y empresas de transporte. Los costos y tiempos de entrega varían según tu ubicación. En CABA y GBA contamos con envío express en el día.",
    isOpen: false
  },
  {
    question: "¿Cómo es el proceso de compra?",
    answer: "1. Seleccioná los productos que deseas<br>2. Agregá al carrito y finaliza la compra<br>3. Te contactaremos por WhatsApp para coordinar el envío<br>4. Realizá el pago por transferencia o efectivo<br>5. ¡Listo! Procesamos tu pedido",
    isOpen: false
  },
  {
    question: "¿Qué métodos de pago aceptan?",
    answer: "Aceptamos múltiples formas de pago:<br>- Transferencia bancaria<br>- Efectivo<br>- Mercado Pago<br>- Tarjetas de débito y crédito<br>- Pago en efectivo contra entrega (solo CABA)",
    isOpen: false
  },
  {
    question: "¿Tienen local físico?",
    answer: "Sí, nuestro local está ubicado en [dirección]. Podés visitarnos de Lunes a Sábados de 10 a 20hs. También podes retirar tus compras online por el local sin cargo.",
    isOpen: false
  },
  {
    question: "¿Puedo cancelar o modificar mi pedido?",
    answer: "Sí, podés modificar o cancelar tu pedido antes de que sea procesado. Contactanos por WhatsApp apenas realices el pedido para hacer cualquier cambio. Una vez que el pedido está en preparación, no se podrán realizar modificaciones.",
    isOpen: false
  },
  {
    question: "¿El envío es discreto?",
    answer: "Sí, todos nuestros envíos son 100% discretos. La mercadería se envía en cajas o bolsas sin identificación del contenido, garantizando tu privacidad.",
    isOpen: false
  }
])

const toggleFaq = (index) => {
  faqs.value[index].isOpen = !faqs.value[index].isOpen
}
</script>

<style scoped>
.faq-section {
  background-color: var(--black-color);
}

.accordion-item {
  background: var(--black-color-2);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.accordion-button {
  background: var(--black-color-2);
  color: var(--white-color);
  padding: 1.25rem;
  font-size: 1.1rem;
  font-weight: 500;
  border: none;
  width: 100%;
  text-align: left;
  transition: all 0.3s ease;
}

.accordion-button:not(.collapsed) {
  background: var(--black-color-3);
  color: var(--primary-color);
}

.accordion-button:hover {
  background: var(--black-color-3);
}

.accordion-body {
  padding: 1.25rem;
  color: var(--white-color-2);
  line-height: 1.6;
  background: var(--black-color-2);
}

.accordion-collapse {
  max-height: 0;
  overflow: hidden;
  transition: max-height .5s ease-in-out;
}

.accordion-collapse.show {
  max-height: 500px;
}

@media (max-width: 768px) {
  .accordion-button {
    font-size: 1rem;
    padding: 1rem;
  }
  
  .accordion-body {
    padding: 1rem;
    font-size: 0.95rem;
  }
}
</style>
